import { Tooltip } from '@festina-life/ui/feedback'
import { useTranslate } from '@festina-life/ui/hooks'
import { Icon, typographyStyles } from '@festina-life/ui/structure'
import cx from 'classnames'

type Props = {
  count: number
}
export const UnapprovedOperations = ({ count }: Props) => {
  const translate = useTranslate()

  return (
    <Tooltip
      tip={translate('branchesTree.status.unapprovedOperationsTooltip', {
        count,
      })}
    >
      <div
        className={cx(
          'flex items-center gap-x-1 px-1',
          typographyStyles({ size: 'sm', intensity: 'secondary' }),
        )}
      >
        {count}
        <Icon name="QuestionMarkCircle" color="unset" />
      </div>
    </Tooltip>
  )
}
